import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Line, LineTurn, Turn } from '../Icons';
export const LevelIndicator = ({ level, isLast, isSectionExpanded }) => {
    const lines = useMemo(() => Array.from({ length: level - 1 }).map((_, index) => isSectionExpanded && index === level - 1 ? (_jsx(LineTurn, {}, index)) : (_jsx(Line, {}, index))), [level, isSectionExpanded]);
    if (level === 0) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [lines, isLast && !isSectionExpanded ? _jsx(Turn, {}) : _jsx(LineTurn, {})] }));
};
